export default function getCurrentTimeZoneName() {
  try {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Sao_Paulo";
  } catch (error) {
    return "America/Sao_Paulo";
  }
}
